var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTop2Leaderboard = function SvgIconTop2Leaderboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__a)",
    d: "M6.627 22.332a2.55 2.55 0 0 0 .929 2.846l2.598 1.89c.202.143.352.349.427.585l.996 3.06a2.54 2.54 0 0 0 2.42 1.76h3.218c.248-.002.49.077.687.226l2.6 1.884a2.545 2.545 0 0 0 2.997 0l2.598-1.884a1.13 1.13 0 0 1 .688-.227h3.217a2.54 2.54 0 0 0 2.42-1.76l.997-3.059c.075-.236.224-.441.427-.584l2.598-1.891a2.55 2.55 0 0 0 .928-2.846l-.996-3.06a1.18 1.18 0 0 1 0-.722l.996-3.059a2.55 2.55 0 0 0-.928-2.846l-2.599-1.89a1.13 1.13 0 0 1-.426-.585l-.997-3.06a2.54 2.54 0 0 0-2.42-1.76h-3.217a1.17 1.17 0 0 1-.688-.22L23.5 3.24a2.54 2.54 0 0 0-2.998 0l-2.599 1.89c-.2.144-.44.221-.687.22h-3.218a2.54 2.54 0 0 0-2.42 1.76l-.996 3.06a1.13 1.13 0 0 1-.427.584l-2.598 1.89a2.55 2.55 0 0 0-.929 2.847l.997 3.06c.076.234.076.487 0 .721zM22 10.397a8.514 8.514 0 1 1-8.511 8.518 8.524 8.524 0 0 1 8.51-8.518"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__b)",
    d: "M22 26.053a7.14 7.14 0 1 0 .007-14.278 7.14 7.14 0 0 0-.008 14.278m-1.74-10.959a2.54 2.54 0 0 1 2.11-.632 2.38 2.38 0 0 1 2.146 1.656c.481 1.582-.509 3.72-2.688 5.892h2.117a.687.687 0 1 1 0 1.375h-3.891a.689.689 0 0 1-.44-1.217c2.922-2.433 3.905-4.592 3.589-5.644a1.02 1.02 0 0 0-.977-.694 1.21 1.21 0 0 0-1.017.26c-.333.422-.5.95-.468 1.486a.688.688 0 0 1-1.375.076 3.55 3.55 0 0 1 .894-2.558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__c)",
    d: "M3.671 35.191a.7.7 0 0 0 .392.695c.144.061 3.176 1.457 5.596 1.25a5.32 5.32 0 0 1-.742 3.026.684.684 0 0 0 .783 1.052c.262-.096 5.652-2.11 8.828-6.36l-1.382-1.003h-3.149a3.86 3.86 0 0 1-3.06-1.478 3.6 3.6 0 0 1-.666-1.231l-.014-.048a12 12 0 0 1-6.064 3.5.69.69 0 0 0-.522.597"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-top2-leaderboard_svg__d)",
    d: "M40.329 35.191a.69.69 0 0 0-.523-.598 12 12 0 0 1-6.064-3.5l-.013.049c-.14.45-.367.868-.667 1.23a3.86 3.86 0 0 1-3.06 1.479h-3.148l-1.382 1.003c3.176 4.25 8.566 6.264 8.827 6.36a.683.683 0 0 0 .784-1.052 5.32 5.32 0 0 1-.743-3.025c2.414.206 5.452-1.19 5.597-1.251a.7.7 0 0 0 .392-.695"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__a",
    x1: 22,
    x2: 22,
    y1: 2.75,
    y2: 35.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__b",
    x1: 22.003,
    x2: 22.003,
    y1: 11.773,
    y2: 26.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__c",
    x1: 11.098,
    x2: 11.098,
    y1: 31.094,
    y2: 41.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-top2-leaderboard_svg__d",
    x1: 32.902,
    x2: 32.902,
    y1: 31.094,
    y2: 41.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828B99"
  })))));
};
export default SvgIconTop2Leaderboard;